import { createQuery } from '@tanstack/svelte-query';
import { fetchLEDScenes } from '$lib/api/led_scene';
import type { LEDScene } from '$lib/types/led_scene';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const ledScenesQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<LEDScene>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['led_scenes', { unitId }],
			queryFn: () => fetchLEDScenes(unitId),
			enabled: unitId > 0
		};
	});
